/**
 * 🚀 LOVABLE LATEST VERSION COMPATIBILITY LAYER
 * Ensures compatibility with latest Lovable features and tools
 */

// Set Lovable version identifier
if (typeof window !== 'undefined') {
  (window as any).__LOVABLE_VERSION__ = 'latest';
  (window as any).__LOVABLE_FEATURES__ = {
    visualEdits: true,
    mobileCapacitor: true,
    supabaseIntegration: true,
    advancedDebugging: true,
    productionBuild: true
  };
}

// Enhanced debugging for Lovable tools
export const lovableDebug = {
  log: (component: string, data: any) => {
    if (import.meta.env.DEV && (window as any).__LOVABLE_VERSION__) {
      console.log(`[LOVABLE:${component}]`, data);
    }
  },
  
  error: (component: string, error: any) => {
    if ((window as any).__LOVABLE_VERSION__) {
      console.error(`[LOVABLE:${component}]`, error);
    }
  }
};

// Type helpers for latest Lovable version
export const ensureArray = <T>(value: any): T[] => Array.isArray(value) ? value : [];
export const safeProperty = <T>(obj: any, prop: string, fallback: T): T => obj?.[prop] ?? fallback;

// Global compatibility setup
if (typeof globalThis !== 'undefined') {
  (globalThis as any).nuclearAssert = <T = any>(value: any): T => value as T;
}

export default {
  version: 'latest',
  features: ['visual-edits', 'mobile-capacitor', 'supabase', 'debugging'],
  lovableDebug,
  ensureArray,
  safeProperty
};